<template>
    <TableLayout :permissions="['business:visits:query']">
        <!-- 搜索表单 -->
        <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
            <el-form-item label="姓名/手机号" prop="name">
                <el-input v-model="searchForm.name" placeholder="请输入姓名/手机号" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="idcardNo">
                <el-input v-model="searchForm.idcardNo" placeholder="请输入身份证号" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="公司名称" prop="companyName">
                <el-input v-model="searchForm.companyName" placeholder="请输入公司名称" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="审批状态" prop="status">
                <el-select v-model="searchForm.status" placeholder="请选择">
                    <el-option label="待审核" value="1"></el-option>
                    <el-option label="正常" value="2"></el-option>
                    <el-option label="迟到" value="3"></el-option>
                    <el-option label="审核退回" value="4"></el-option>
                    <el-option label="超期自动签离" value="5"></el-option>
                    <el-option label="已签离" value="6"></el-option>
                    <el-option label="超期未签离" value="7"></el-option>
                    <el-option label="已到达" value="8"></el-option>
                    <el-option label="审核失效" value="9"></el-option>
                    <el-option label="邀约中" value="10"></el-option>
                    <el-option label="邀约失效" value="11"></el-option>
                </el-select>
            </el-form-item>
            <section>
                <el-button type="primary" @click="search">搜索</el-button>
<!--                <el-button type="primary" :loading="isWorking.export" v-permissions="['business:visits:exportExcel']" @click="exportExcel">导出</el-button>-->
                <el-button @click="reset">重置</el-button>
            </section>
        </el-form>
        <!-- 表格和分页 -->
        <template v-slot:table-wrap>
          <ul class="toolbar"  v-permissions="['business:visits:sync']">
            <li><el-button type="primary"  v-permissions="['business:visits:sync']" @click="$refs.OperaVisitsHkWindow.open('同步访客记录')">同步</el-button></li>
          </ul>
            <el-table
                v-loading="isWorking.search"
                :data="tableData.list"
                stripe
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="name" label="访客姓名" min-width="100px"></el-table-column>
                <el-table-column prop="phone" label="手机号" min-width="100px"></el-table-column>
                <el-table-column prop="companyName" label="公司名称" min-width="100px"></el-table-column>
                <el-table-column prop="receptMemberName" label="被访人" min-width="100px"></el-table-column>
                <el-table-column prop="reason" label="拜访事由" min-width="100px"></el-table-column>
                <el-table-column label="拜访时间" min-width="170px">
                    <template slot-scope="{row}">
                        <span>起：{{row.starttime}}</span><br/>
                        <span>止：{{row.endtime}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="随访人员" min-width="100px">
                    <template slot-scope="{row}">
                        <span>{{row.memberNum || '-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="随访车辆" min-width="100px">
                    <template slot-scope="{row}">
                        <span v-if="row.carNos">{{row.carNos.split(',').length}}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" fixed="right" label="状态" min-width="100px">
                    <template slot-scope="{row}">
                        <span v-if="row.status === 1">待审核</span>
                        <span v-if="row.status === 2">正常</span>
                        <span v-if="row.status === 3">迟到</span>
                        <span v-if="row.status === 4">审核退回</span>
                        <span v-if="row.status === 5">超期自动签离</span>
                        <span v-if="row.status === 6">已签离</span>
                        <span v-if="row.status === 7">超期未签离</span>
                        <span v-if="row.status === 8">已到达</span>
                        <span v-if="row.status === 9">审核失效</span>
                        <span v-if="row.status === 10">邀约中</span>
                        <span v-if="row.status === 11">邀约失效</span>
                    </template>
                </el-table-column>
                <el-table-column
                    v-if="containPermissions(['business:visits:update', 'business:visits:delete'])"
                    label="操作"
                    min-width="100"
                    fixed="right"
                >
                    <template slot-scope="{row}">
                        <el-button type="text" @click="$refs.OperaVisitsDesWindow.open('详情', row.id)" v-permissions="['business:visits:update']">查看详情</el-button>
<!--                        <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:visits:delete']">查询审批结果</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
            <pagination
                @size-change="handleSizeChange"
                @current-change="handlePageChange"
                :pagination="tableData.pagination"
            >
            </pagination>
            <!--      详情      -->
            <OperaVisitsDesWindow ref="OperaVisitsDesWindow" />
            <OperaVisitsHkWindow ref="OperaVisitsHkWindow" @success="search()" />
        </template>
    </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaVisitsDesWindow from '@/components/business/OperaVisitsDesWindow'
import OperaVisitsHkWindow from '@/components/business/OperaVisitsHkWindow'
export default {
  name: 'Visits',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaVisitsDesWindow,OperaVisitsHkWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        name: '',
        companyName: '',
        idcardNo: '',
        status: ''
      }
    }
  },
  created () {
    this.config({
      module: '访客申请信息表',
      api: '/business/visits',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  methods: {
  }
}
</script>
